import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoreServiceService {
  public toggleSidebar: EventEmitter<any> = new EventEmitter();
  constructor() { }
}
